<div class="sn-env-bar" [class.sn-env-bar--impersonating]="!!impersonatedName" role="status" *ngIf="visible">
  <span class="sn-env-bar__label" *ngIf="label">{{ label }}</span>
  <a
    *ngIf="label && showDetailsLink"
    class="sn-env-bar__link"
    [routerLink]="detailsRoute">
    Click Here for More Info
  </a>
  <span class="sn-env-bar__separator" *ngIf="label && impersonatedName" aria-hidden="true">|</span>
  <span class="sn-env-bar__label" *ngIf="impersonatedName">
    You are masquerading as {{ impersonatedName }}
  </span>
  <button
    *ngIf="impersonatedName"
    type="button"
    class="sn-env-bar__action"
    (click)="onRevert()">
    Revert to your user
  </button>
</div>
